import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

export type LineMarketSlotCoalesceConfig = {
    inPlayOnly: boolean;
    /**
     * Sticky line markets kept per grouping name, keyed by sport id.
     * Sports not listed fall back to `defaultMaxSlotsPerGroup`.
     * `null` = uncapped (stabilize only — no line collapse).
     */
    maxSlotsPerGroupBySport: Readonly<Record<string, number>>;
    /** `null` = uncapped stabilize-only for sports without an override. */
    defaultMaxSlotsPerGroup: number | null;
};

export const LINE_MARKET_SLOT_COALESCE_CONFIG: LineMarketSlotCoalesceConfig = {
    inPlayOnly: true,
    maxSlotsPerGroupBySport: {
        basketball: 1,
        tennis: 3,
    },
    defaultMaxSlotsPerGroup: null,
};

/**
 * Enabled for in-play on the Genius/unified EventMarkets path.
 * Sport allowlisting is owned by `unifiedComponentConfig` / `geniusSports`.
 */
export const shouldEnableLineMarketSlotCoalesce = (
    eventId: EventId,
    config: LineMarketSlotCoalesceConfig = LINE_MARKET_SLOT_COALESCE_CONFIG
): boolean => {
    const event = eventId.getEventModel();
    if (event === null) {
        return false;
    }

    if (config.inPlayOnly && event.timeSettingsStarted === false) {
        return false;
    }

    return true;
};

export const getLineMarketSlotCoalesceMaxSlots = (
    eventId: EventId,
    config: LineMarketSlotCoalesceConfig = LINE_MARKET_SLOT_COALESCE_CONFIG
): number | null => {
    const event = eventId.getEventModel();
    if (event === null) {
        return config.defaultMaxSlotsPerGroup;
    }

    return config.maxSlotsPerGroupBySport[event.sport] ?? config.defaultMaxSlotsPerGroup;
};
